export * from './hooks/useInput';
export * from './hooks/useFormInstance';
import BaseForm from './BaseForm';
import Item from './Item';
// Create the Form object with both BaseForm and Item component
const Form = BaseForm;
Form.Item = Item;
export default Form;
//# sourceMappingURL=index.js.map